export default __webpack_public_path__ + "static/media/585_6.76d41cd6.jpg";